/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, ViewChild, ElementRef } from '@angular/core';
import { CommonService } from 'app/shared/services/common.service';

@Component({
    template: `
        <div class="custom-access-header">
            <div ngSwitch="{{params.headerType}}" class="customHeaderLabel">
                <div *ngSwitchCase="'accessLevels'" class="clearfix access-levels">
                    <div *ngFor="let level of params.accessLevels" class="text-center pull-left" [style.width.%]="25">
                        <p class="access-level mb0"  [ngClass]="{'active': level.filterActive}">
                            <em class="close-icon click-class" (click)="removeLevelFilter(level, $event)" *ngIf="level.filterActive">
                                <img src="app/assets/images/white-close.svg">
                            </em>
                            <span (click)="levelClicked(level, $event)" class="click-class filter-name">{{level.headerName}}</span>
                        </p>
                    </div>
                </div>
                <button type="button" class="btn icon-btn alp-sort-icon" *ngSwitchCase="'alpSorting'" (click)="onAlpSortRequested()" title="{{ getTranslationWithKey('sort_by_name') }}">
                    <i class="fa sort-icons {{alpSortClass}}"></i>
                </button>
                <button type="button" class="btn icon-btn" *ngSwitchCase="'levelSorting'" (click)="onLevelSortRequested()" title="{{ getTranslationWithKey('sort_by_level') }}">
                    <i class="{{levelSortClass}}"></i>
                </button>
                <div *ngSwitchDefault>{{params.displayName}}</div> 
            </div>
        </div>
    `,
    styleUrls: ['./permissions-custom-header.component.scss'],
})
export class PermissionsCustomHeader {
    @ViewChild('menuButton', { read: ElementRef }) public menuButton: any;
    public params: any;
    public ascSort!: string;
    public descSort!: string;
    public noSort!: string;
    private alpSortOrders = [
        { sortType: '', sortClass: 'fa-sort-alpha-desc' },
        { sortType: 'desc', sortClass: 'fa-sort-alpha-desc active' },
        { sortType: 'asc', sortClass: 'fa-sort-alpha-asc active' }
    ];
    private levelSortOrders = [
        { sortType: '', sortClass: 'icon-sort-descending' },
        { sortType: 'desc', sortClass: 'icon-sort-descending active' },
        { sortType: 'asc', sortClass: 'icon-sort-ascending active' }
    ];
    private alpSortIndex = 0;
    private levelSortIndex = 0;
    public alpSortClass = 'fa-sort-alpha-desc';
    public levelSortClass = 'icon-sort-descending';
    public toggleFilter = false;

    constructor(private commonService: CommonService) {}

    agInit(params: any): void {
        this.params = params;
        if (this.params.accessLevels) { /* Retain Filtering on tabs change*/
            this.params.context.componentParent.filterRowData(this.params);
        }
    }

    public onAlpSortRequested() {
        this.alpSortIndex = ++this.alpSortIndex % this.alpSortOrders.length;
        const sortOrder = this.alpSortOrders[this.alpSortIndex];
        this.alpSortClass = sortOrder.sortClass;
        const targetCol = 'ag-Grid-AutoColumn';
        const columnApi = this.params.columnApi;
        let currentSort = null;
        const model = columnApi.getColumnState() || [];
        const entry = model.find((m: any) => m.colId === targetCol);
        if (entry) currentSort = entry.sort;
        const cycle = [null, 'asc', 'desc'];
        const next = cycle[(cycle.indexOf(currentSort) + 1) % cycle.length];
        setTimeout(() => {
            columnApi.applyColumnState({
                state: [{ colId: targetCol, sort: next }],
                defaultState: {}
            });
        }, 0);
    }

    public onLevelSortRequested() {
        this.levelSortIndex = ++this.levelSortIndex % this.levelSortOrders.length;
        const sortOrder = this.levelSortOrders[this.levelSortIndex];
        this.levelSortClass = sortOrder.sortClass;
        const targetCol = 'accessSteps';
        const columnApi = this.params.columnApi;
        let currentSort = null;
        const model = columnApi.getColumnState() || [];
        const entry = model.find((m: any) => m.colId === targetCol);
        if (entry) currentSort = entry.sort;
        const cycle = [null, 'asc', 'desc'];
        const next = cycle[(cycle.indexOf(currentSort) + 1) % cycle.length];
        setTimeout(() => {
            columnApi.applyColumnState({
                state: [{ colId: targetCol, sort: next }],
                defaultState: {}
            });
        }, 0);
    }

    public levelClicked(level: any, event: any) {
        level.filterActive = true;
        this.params.context.componentParent.filterRowData(this.params);
    }

    public removeLevelFilter(level: any, event: any) {
        level.filterActive = false;
        this.params.context.componentParent.filterRowData(this.params);
    }

    public getTranslationWithKey(key: string) {
        return this.commonService.getTranslatedVal(key);
    }
}
